import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Dropdown } from 'carbon-components-react'

import { keys } from 'lodash'

import './index.scss'

const getLangName = (shortLang, { short, full }) =>
  shortLang && short ? short : full

const LanguageSwitch = ({
  languages,
  onChange,
  selectedLanguage,
  shortLanguage,
  className,
  id = 'language-switch',
  ariaLabel = 'Language'
}) => (
  <div className='language-switch__wrapper'>
    <Dropdown
      id={id}
      className={cx('language-switch', className)}
      ariaLabel={ariaLabel}
      items={keys(languages)}
      selectedItem={selectedLanguage}
      itemToString={(id) => getLangName(shortLanguage, languages[id])}
      onChange={({ selectedItem }) => onChange(selectedItem)}
      label=''
    />
  </div>
)

export const Languages = PropTypes.objectOf(
  PropTypes.shape({
    full: PropTypes.string.isRequired,
    short: PropTypes.string
  })
)

LanguageSwitch.propTypes = {
  /** An object that provide the list of supported languages */
  languages: Languages.isRequired,
  /** The function that handles languge change */
  onChange: PropTypes.func.isRequired,
  /** The language selected from the dropdown list */
  selectedLanguage: PropTypes.string.isRequired,
  /** A boolean flag to provide the short language code */
  shortLanguage: PropTypes.bool,
  /** The string that indicates the className to use */
  className: PropTypes.string,
  /** A string ID */
  id: PropTypes.string,
  /** A string value that indicates the language label */
  ariaLabel: PropTypes.string
}

export default React.memo(LanguageSwitch)
